import { InfoCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'

import type { OfferPriceType } from '@/types'
import {
  getPriceSourceText,
  getPriceUnavailableText,
  PRICE_UNAVAILABLE_TEXT,
} from '@/utils/products/offerAvailability'

import TooltipLines from '../TooltipLines/TooltipLines'
import cn from './PriceUnavailable.module.scss'

interface PriceUnavailableProps {
  price: Pick<OfferPriceType, 'unavailableReason' | 'priceSource'> | undefined
}

function PriceUnavailable({ price }: PriceUnavailableProps) {
  const reasonText = getPriceUnavailableText(price)
  const sourceText = getPriceSourceText(price?.priceSource)
  if (reasonText === undefined && sourceText === undefined) {
    return <>{PRICE_UNAVAILABLE_TEXT}</>
  }

  return (
    <Tooltip title={<TooltipLines lines={[reasonText, sourceText]} />}>
      <span className={cn.priceUnavailable}>
        {PRICE_UNAVAILABLE_TEXT}
        <InfoCircleOutlined className={cn.icon} aria-label="Почему нет цены" />
      </span>
    </Tooltip>
  )
}

export default PriceUnavailable
